<template>
  <div>
    <editor
      @input="$emit('input', $event)"
      ref="editor"
      :init="onlyBold ? onlyBoldEditorInit : editorInit"
      :value="value"
    >
    </editor>
  </div>
</template>
<script>
import tinymce from 'tinymce/tinymce'
import 'tinymce/themes/modern/theme'
import 'tinymce/skins/lightgray/content.min.css'
import 'tinymce/skins/lightgray/skin.min.css'
import ImagesDialog from '@/components/inputs/ImageDialog/'
import Vue from 'vue'
import { Attachment } from '@/api'

// plugins
import 'tinymce/plugins/advlist'
import 'tinymce/plugins/image'
import 'tinymce/plugins/autoresize'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/link'
import 'tinymce/plugins/media'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/code'

export default {
  props: {
    value: { type: String },
    onlyBold: { type: Boolean }
  },
  data() {
    return {
      bus: new Vue(),
      activeInput: null,
      innerVisible: false,
      editorInit: {
        resize: false,
        menubar: false,
        plugins:
          'advlist image autoresize imagetools textcolor colorpicker paste media link code',
        toolbar: 'bold italic underline backcolor forecolor | link code',
        height: '3.6em',
        setup: editor => {
          editor.on('keydown', this.preventEnterCallback)
        }
      },
      onlyBoldEditorInit: {
        resize: false,
        menubar: false,
        plugins: '',
        toolbar: 'bold',
        height: '3.6em',
        setup: editor => {
          editor.on('keydown', this.preventEnterCallback)
        }
      }
    }
  },
  methods: {
    preventEnterCallback(event) {
      if (event.keyCode === 13) {
        event.preventDefault()
        event.stopPropagation()
        return false
      }
      return true
    }
  },
  watch: {
    value(value) {
      if (value === undefined) {
        this.$emit('input', '')
      }
    }
  }
}
</script>
